import axios from 'axios';

const BASE_URL = "https://api.coingecko.com/api/v3";
export const getMarketData = async () => {
    try{
        const response = await axios.get(`${BASE_URL}/coins/markets`, {
            params :{
                vs_currency: "usd",
                order: "market_cap_desc",
                per_page: 10,
                page: 1,
                sparkline: true,
            }
        }
    );
    console.log("Sparkline data:", response.data[0].sparkline_in_7d.price);
     return response.data.map(coin=>({
          ...coin,
          chart: "/path/to/default-chart.png",
     }))
    }
    catch(error){
        console.error("Failed to load:",  error)
    }

}